import React from 'react'
import { Box, Typography } from '@mui/material'
import Lottie from 'lottie-react'
import { waveAnimated } from '../../../assets'
import { OTPInput, ResendOTPButton, BasketLoading, ButtonLoading, HeaderPage } from '../../Simple/'
import { AuthContext } from '../../../contexts/AuthContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { LocalStorage, Services } from '../../../services'
import RouterHook from '../../../contexts/RouterHook'
import CryptoJS from 'crypto-js'

const VerificaCodigo = () => {
  const { sttAuthCtx, actionsAuth, userInfo, uiControls, loadsAuth } = React.useContext(AuthContext)
  const { actionsUCtx } = React.useContext(UsuarioContext)
  const serverRouter = RouterHook()

  const handleVerifyCode = async () => {
    const req = await actionsAuth.VerificaCodigoOTP(userInfo.otpCode)
    //console.log('reqAS', req)
    if (req.retorno === true && req.usuario && req.type === 1) {
      //console.log('req.tokens', req)
      actionsUCtx.handleUsuario(req.usuario)

      const bytes = CryptoJS.AES.decrypt(req.tokens.accessToken, import.meta.env.VITE_CRYPTO_KEY)
      LocalStorage.set('user-token', bytes.toString(CryptoJS.enc.Utf8))

      const bytesRefresh = CryptoJS.AES.decrypt(req.tokens.refreshToken, import.meta.env.VITE_CRYPTO_KEY)
      LocalStorage.set('user-refreshToken', bytesRefresh.toString(CryptoJS.enc.Utf8))

      let query = ''
      let usuario = req.usuario
      if (usuario.cidade && usuario.estado) {
        query = `${usuario.estado.length === 2 ? usuario.estado : Services.ReturnSiglaEstado(usuario.estado)}-${Services.RemoveCaracteresEspeciais(
          usuario.cidade,
        )}`
      } else {
        query = ':localizacao'
      }
      const url = LocalStorage.get('url-selecionada')
      actionsAuth.clearUiControls()
      if (url) {
        // url esta https://site.agendeiquadras.com.br/centro-esportivo/query pegar ultima parte depois do /
        query = url.url.split('/').pop()
        LocalStorage.remove('url-selecionada')
        LocalStorage.set('back-action', true)
        serverRouter('centro-esportivo', query)
      } else {
        //console.log('query', query)
        serverRouter('home', query.toLowerCase())
      }
    }
  }

  // console.log('uiControls', uiControls)
  return (
    <>
      {loadsAuth === 'login' && <BasketLoading />}
      <Box sx={{ height: '100%', py: 1.5, overflow: 'hidden' }}>
        <HeaderPage action={() => actionsAuth.authStep('verifEmail')} />
        <Box sx={{ px: 1.5, py: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography variant='h6'>
            Digite o código de 6 dígitos que enviamos para seu e-mail: <strong>{userInfo.email}</strong>
          </Typography>

          <OTPInput
            onChange={actionsAuth.handleInputChange}
            error={uiControls.codeValido !== null ? !uiControls.codeValido : false}
            helperText={uiControls.otpCodeHelperText}
          />
          <ButtonLoading
            fullWidth
            disabled={userInfo.otpCode.length !== 6}
            variant='contained'
            onClick={handleVerifyCode}
            loading={loadsAuth === 'login'}
          >
            Continuar
          </ButtonLoading>
          <ResendOTPButton
            seconds={60}
            createdAt={sttAuthCtx.listEmails?.createdAt}
            waitingText={'Reenviar código em {time}'}
            actionText={'Reenviar código'} // 🔥 Texto do botão
            onResend={() => actionsAuth.EnviarCodigoEmail(userInfo.email)}
          />
        </Box>
        <Lottie
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '30%',
            transform: 'rotate(180deg)',
          }}
          animationData={waveAnimated}
          rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
        />
      </Box>
    </>
  )
}

export default VerificaCodigo

/**
 *
 *Mudar o hover
 *
 */
